import { Component, Input, NgModule } from '@angular/core';
import { ProviderName, config, CardTokenService, CardTokenQuery, FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { topUpAddressConfigDefault, TopUpAddressModule } from '@fgb/portal-component-library/src/lib/shared/top-up-address';
import { RegexUS } from '@fgb/portal-component-library/src/lib/shared/utilities';
import { CommonModule } from '@angular/common';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoadingModule } from '@fgb/portal-component-library/src/lib/shared/loading';
import { ConfirmModalModule } from '@fgb/portal-component-library/src/lib/shared/confirm-modal';
import { CountryAndRegionsModule } from '@fgb/portal-component-library/src/lib/shared/country-and-regions';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@fgb/core';
import * as ɵngcc2 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc3 from '@fgb/portal-component-library/src/lib/shared/top-up-address';
import * as ɵngcc4 from '@angular/common';
import * as ɵngcc5 from '@ngx-translate/core';
import * as ɵngcc6 from '@fgb/portal-component-library/src/lib/shared/confirm-modal';
import * as ɵngcc7 from '@fgb/portal-component-library/src/lib/pipes';
import * as ɵngcc8 from 'ngx-owl-carousel-o';
import * as ɵngcc9 from '@fgb/portal-component-library/src/lib/shared/loading';

function AddNewCardComponent_ng_template_14_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵelementStart(1, "button", 16);
    ɵngcc0.ɵɵlistener("click", function AddNewCardComponent_ng_template_14_div_10_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(2); return ctx_r4.cancel(); });
    ɵngcc0.ɵɵtext(2, "Cancel");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function AddNewCardComponent_ng_template_14_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵelementStart(1, "div", 8);
    ɵngcc0.ɵɵelementStart(2, "span", 9);
    ɵngcc0.ɵɵtext(3, "add_card");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "h6", 10);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 11);
    ɵngcc0.ɵɵelementStart(8, "fgbcl-top-up-address", 12);
    ɵngcc0.ɵɵlistener("submittedAddress", function AddNewCardComponent_ng_template_14_Template_fgbcl_top_up_address_submittedAddress_8_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.submittedAddress($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(9, "div", 13);
    ɵngcc0.ɵɵtemplate(10, AddNewCardComponent_ng_template_14_div_10_Template, 3, 0, "div", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 5, "new.card.form.title"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("regex", ctx_r1.regex)("topUpAddressConfig", ctx_r1.topUpAddressConfig)("hidden", ctx_r1.hideAddress);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.showCancelButton);
} }
function CardTokenComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function CardTokenComponent_ng_template_1_p_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 17);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "payment.card.active"));
} }
function CardTokenComponent_ng_template_1_p_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 18);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "payment.card.inactive"));
} }
function CardTokenComponent_ng_template_1_p_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 19);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "payment.card.frozen"));
} }
const _c0 = function (a0, a1, a2) { return { "active-card": a0, "inactive-card": a1, "frozen-card": a2 }; };
function CardTokenComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵelementStart(1, "div", 8);
    ɵngcc0.ɵɵtemplate(2, CardTokenComponent_ng_template_1_p_2_Template, 3, 3, "p", 9);
    ɵngcc0.ɵɵtemplate(3, CardTokenComponent_ng_template_1_p_3_Template, 3, 3, "p", 10);
    ɵngcc0.ɵɵtemplate(4, CardTokenComponent_ng_template_1_p_4_Template, 3, 3, "p", 11);
    ɵngcc0.ɵɵelementStart(5, "button", 12);
    ɵngcc0.ɵɵlistener("click", function CardTokenComponent_ng_template_1_Template_button_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.switchCardSide(); });
    ɵngcc0.ɵɵelement(6, "span", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 14);
    ɵngcc0.ɵɵelementStart(8, "p", 15);
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵpipe(10, "creditCardNumber");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(11, "img", 16);
    ɵngcc0.ɵɵpipe(12, "cardTypeImageUrl");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(12, _c0, ctx_r2.cardIsActive(), ctx_r2.cardIsInactive(), ctx_r2.cardIsFrozen()));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.cardIsActive());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.cardIsInactive());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.cardIsFrozen());
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r2.cardIsInactive() ? "text-black" : "text-white");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r2.cardIsInactive() ? "text-black" : "text-white");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(10, 8, ctx_r2.cardToken.CardNumber), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵpropertyInterpolate("src", ɵngcc0.ɵɵpipeBind1(12, 10, ctx_r2.cardToken.CardType), ɵngcc0.ɵɵsanitizeUrl);
} }
function CardTokenComponent_ng_template_3_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 29);
    ɵngcc0.ɵɵlistener("confirm", function CardTokenComponent_ng_template_3_button_4_Template_button_confirm_0_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r21 = ɵngcc0.ɵɵnextContext(2); return ctx_r21.freezeCard(); });
    ɵngcc0.ɵɵelementStart(1, "label", 30);
    ɵngcc0.ɵɵelementStart(2, "span", 31);
    ɵngcc0.ɵɵtext(3, "ac_unit");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "span");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext(2);
    const _r5 = ɵngcc0.ɵɵreference(6);
    ɵngcc0.ɵɵproperty("confirmContent", _r5);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 2, "payment.card.freeze.label"));
} }
function CardTokenComponent_ng_template_3_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r24 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 32);
    ɵngcc0.ɵɵlistener("confirm", function CardTokenComponent_ng_template_3_button_5_Template_button_confirm_0_listener() { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r23 = ɵngcc0.ɵɵnextContext(2); return ctx_r23.setCardAsDefault(); });
    ɵngcc0.ɵɵelementStart(1, "label", 30);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext(2);
    const _r11 = ɵngcc0.ɵɵreference(12);
    ɵngcc0.ɵɵproperty("confirmContent", _r11);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 2, "payment.card.activate.label"));
} }
function CardTokenComponent_ng_template_3_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r26 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 33);
    ɵngcc0.ɵɵlistener("confirm", function CardTokenComponent_ng_template_3_button_6_Template_button_confirm_0_listener() { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r25 = ɵngcc0.ɵɵnextContext(2); return ctx_r25.unfreezeCard(); });
    ɵngcc0.ɵɵelementStart(1, "label", 30);
    ɵngcc0.ɵɵelementStart(2, "span", 31);
    ɵngcc0.ɵɵtext(3, "light_mode");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "span");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext(2);
    const _r7 = ɵngcc0.ɵɵreference(8);
    ɵngcc0.ɵɵproperty("confirmContent", _r7);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 2, "payment.card.unfreeze.label"));
} }
function CardTokenComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 20);
    ɵngcc0.ɵɵelementStart(1, "div", 21);
    ɵngcc0.ɵɵelementStart(2, "button", 22);
    ɵngcc0.ɵɵlistener("click", function CardTokenComponent_ng_template_3_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r27 = ɵngcc0.ɵɵnextContext(); return ctx_r27.switchCardSide(); });
    ɵngcc0.ɵɵelement(3, "span", 23);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, CardTokenComponent_ng_template_3_button_4_Template, 7, 4, "button", 24);
    ɵngcc0.ɵɵtemplate(5, CardTokenComponent_ng_template_3_button_5_Template, 4, 4, "button", 25);
    ɵngcc0.ɵɵtemplate(6, CardTokenComponent_ng_template_3_button_6_Template, 7, 4, "button", 26);
    ɵngcc0.ɵɵelementStart(7, "button", 27);
    ɵngcc0.ɵɵlistener("confirm", function CardTokenComponent_ng_template_3_Template_button_confirm_7_listener() { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r29 = ɵngcc0.ɵɵnextContext(); return ctx_r29.deleteCard(); });
    ɵngcc0.ɵɵelementStart(8, "label", 28);
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵpipe(10, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    const _r9 = ɵngcc0.ɵɵreference(10);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.cardIsActive());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.cardIsInactive());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.cardIsFrozen());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("confirmContent", _r9);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(10, 5, "payment.card.delete.label"));
} }
const _c1 = function (a0) { return { cardEnding: a0 }; };
function CardTokenComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 34);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(2, 1, "payment.card.freeze.confirmation", ɵngcc0.ɵɵpureFunction1(4, _c1, ctx_r6.cardToken.CardNumber.substring(12))), " ");
} }
function CardTokenComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 34);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(2, 1, "payment.card.unfreeze.confirmation", ɵngcc0.ɵɵpureFunction1(4, _c1, ctx_r8.cardToken.CardNumber.substring(12))), " ");
} }
function CardTokenComponent_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 34);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(2, 1, "payment.card.delete.confirmation", ɵngcc0.ɵɵpureFunction1(4, _c1, ctx_r10.cardToken.CardNumber.substring(12))), " ");
} }
function CardTokenComponent_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 34);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(2, 1, "payment.card.activation.confirmation", ɵngcc0.ɵɵpureFunction1(4, _c1, ctx_r12.cardToken.CardNumber.substring(12))), " ");
} }
function CardTokenListComponent_ng_container_5_ng_container_1_3_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fgbcl-card-token", 12);
} if (rf & 2) {
    const cardTokens_r3 = ɵngcc0.ɵɵnextContext(3).ngIf;
    ɵngcc0.ɵɵproperty("cardToken", cardTokens_r3.defaultCard);
} }
function CardTokenListComponent_ng_container_5_ng_container_1_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, CardTokenListComponent_ng_container_5_ng_container_1_3_ng_template_0_Template, 1, 1, "ng-template", 11);
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("width", 224);
} }
function CardTokenListComponent_ng_container_5_ng_container_1_ng_container_4_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fgbcl-card-token", 12);
} if (rf & 2) {
    const card_r12 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("cardToken", card_r12);
} }
function CardTokenListComponent_ng_container_5_ng_container_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CardTokenListComponent_ng_container_5_ng_container_1_ng_container_4_ng_template_1_Template, 1, 1, "ng-template", 11);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("width", 224);
} }
function CardTokenListComponent_ng_container_5_ng_container_1_5_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 13);
} }
function CardTokenListComponent_ng_container_5_ng_container_1_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, CardTokenListComponent_ng_container_5_ng_container_1_5_ng_template_0_Template, 1, 0, "ng-template", 11);
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("width", 224);
} }
function CardTokenListComponent_ng_container_5_ng_container_1_9_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fgbcl-card-token", 12);
} if (rf & 2) {
    const cardTokens_r3 = ɵngcc0.ɵɵnextContext(3).ngIf;
    ɵngcc0.ɵɵproperty("cardToken", cardTokens_r3.defaultCard);
} }
function CardTokenListComponent_ng_container_5_ng_container_1_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, CardTokenListComponent_ng_container_5_ng_container_1_9_ng_template_0_Template, 1, 1, "ng-template", 11);
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("width", 224);
} }
function CardTokenListComponent_ng_container_5_ng_container_1_ng_container_10_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fgbcl-card-token", 12);
} if (rf & 2) {
    const token_r18 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("cardToken", token_r18);
} }
function CardTokenListComponent_ng_container_5_ng_container_1_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CardTokenListComponent_ng_container_5_ng_container_1_ng_container_10_ng_template_1_Template, 1, 1, "ng-template", 11);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("width", 224);
} }
function CardTokenListComponent_ng_container_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵelementStart(2, "owl-carousel-o", 7);
    ɵngcc0.ɵɵtemplate(3, CardTokenListComponent_ng_container_5_ng_container_1_3_Template, 1, 1, undefined, 5);
    ɵngcc0.ɵɵtemplate(4, CardTokenListComponent_ng_container_5_ng_container_1_ng_container_4_Template, 2, 1, "ng-container", 8);
    ɵngcc0.ɵɵtemplate(5, CardTokenListComponent_ng_container_5_ng_container_1_5_Template, 1, 1, undefined, 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(6, "hr", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 10);
    ɵngcc0.ɵɵelementStart(8, "owl-carousel-o", 7);
    ɵngcc0.ɵɵtemplate(9, CardTokenListComponent_ng_container_5_ng_container_1_9_Template, 1, 1, undefined, 5);
    ɵngcc0.ɵɵtemplate(10, CardTokenListComponent_ng_container_5_ng_container_1_ng_container_10_Template, 2, 1, "ng-container", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const cardTokens_r3 = ɵngcc0.ɵɵnextContext().ngIf;
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("options", ctx_r4.customOptions);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", cardTokens_r3.defaultCard);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", cardTokens_r3.otherCards);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", cardTokens_r3.otherCards);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("options", ctx_r4.customOptions2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", cardTokens_r3.defaultCard);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", cardTokens_r3.otherCards);
} }
function CardTokenListComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CardTokenListComponent_ng_container_5_ng_container_1_Template, 11, 7, "ng-container", 5);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const cardTokens_r3 = ctx.ngIf;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", cardTokens_r3.defaultCard || cardTokens_r3.otherCards.length);
} }
function CardTokenListComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fgbcl-loading");
} }
const _c2 = function (a0, a1) { return { defaultCard: a0, otherCards: a1 }; };
class AddNewCardComponent {
    constructor(cardTokenService, modalService) {
        this.cardTokenService = cardTokenService;
        this.modalService = modalService;
        this.regex = RegexUS;
        this.provider = ProviderName.Sage;
        this.redirectUrl = '/cardtoken/result';
        this.failureUrl = '/cardtoken/result';
        this.topUpAddressConfig = topUpAddressConfigDefault;
        this.config = config;
        this.hideAddress = false;
        this.showCancelButton = false;
    }
    ngOnInit() { }
    addNewCard() {
        this.cardTokenService.addNewCardToken(this.provider, this.config.portalUrl + this.redirectUrl, 'payment-gateway-area', this.config.portalUrl + this.failureUrl);
        this.showCancelButton = true;
    }
    openCardModal(content) {
        this.showCancelButton = false;
        this.hideAddress = false;
        this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });
    }
    submittedAddress(submitted) {
        if (submitted) {
            this.hideAddress = true;
            this.addNewCard();
        }
    }
    cancel() {
        this.modalService.dismissAll();
    }
}
AddNewCardComponent.ɵfac = function AddNewCardComponent_Factory(t) { return new (t || AddNewCardComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.CardTokenService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.NgbModal)); };
AddNewCardComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AddNewCardComponent, selectors: [["fgbcl-add-new-card"]], inputs: { regex: "regex", provider: "provider", redirectUrl: "redirectUrl", failureUrl: "failureUrl", topUpAddressConfig: "topUpAddressConfig" }, decls: 16, vars: 6, consts: [[1, "d-none", "d-lg-flex"], [1, "btn", "add-card", "d-flex", "flex-column", "align-items-center", "justify-content-center", 3, "click"], ["aria-hidden", "true", 1, "icon", "material-icons"], [1, "font-size-14", "mb-0", "cursor-pointer", "add-card-label"], [1, "d-block", "d-lg-none", "w-100"], [1, "btn", "w-100", "add-card", "d-flex", "flex-row", "align-items-center", "justify-content-center", 3, "click"], ["addNewCardForm", ""], [1, "container", "p-2", "overflow-auto"], [1, "header", "d-flex", "flex-row", "justify-content-center", "mt-3"], ["aria-hidden", "true", 1, "icon", "material-icons", "text-black", "mr-2"], [1, "mt-1", "font-weight-bold"], [1, "content", "px-lg-4"], [3, "regex", "topUpAddressConfig", "hidden", "submittedAddress"], ["id", "payment-gateway-area", 1, "p-1", "mt-3"], ["class", "d-flex flex-row justify-content-center mb-3", 4, "ngIf"], [1, "d-flex", "flex-row", "justify-content-center", "mb-3"], ["id", "cancel-button", 1, "btn", "btn-danger", "w-50", "font-weight-bold", 3, "click"]], template: function AddNewCardComponent_Template(rf, ctx) { if (rf & 1) {
        const _r8 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "button", 1);
        ɵngcc0.ɵɵlistener("click", function AddNewCardComponent_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r8); const _r0 = ɵngcc0.ɵɵreference(15); return ctx.openCardModal(_r0); });
        ɵngcc0.ɵɵelementStart(2, "span", 2);
        ɵngcc0.ɵɵtext(3, "add_card");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "label", 3);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵpipe(6, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 4);
        ɵngcc0.ɵɵelementStart(8, "button", 5);
        ɵngcc0.ɵɵlistener("click", function AddNewCardComponent_Template_button_click_8_listener() { ɵngcc0.ɵɵrestoreView(_r8); const _r0 = ɵngcc0.ɵɵreference(15); return ctx.openCardModal(_r0); });
        ɵngcc0.ɵɵelementStart(9, "span", 2);
        ɵngcc0.ɵɵtext(10, "add_circle_outline");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "label", 3);
        ɵngcc0.ɵɵtext(12);
        ɵngcc0.ɵɵpipe(13, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(14, AddNewCardComponent_ng_template_14_Template, 11, 7, "ng-template", null, 6, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 2, "new.card.button.label"));
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(13, 4, "new.card.button.label"));
    } }, directives: [ɵngcc3.TopUpAddressComponent, ɵngcc4.NgIf], pipes: [ɵngcc5.TranslatePipe], styles: ["button[_ngcontent-%COMP%]:hover{color:#fff}.add-card-label[_ngcontent-%COMP%]{text-transform:uppercase}"] });
AddNewCardComponent.ctorParameters = () => [
    { type: CardTokenService },
    { type: NgbModal }
];
AddNewCardComponent.propDecorators = {
    regex: [{ type: Input }],
    provider: [{ type: Input }],
    redirectUrl: [{ type: Input }],
    failureUrl: [{ type: Input }],
    topUpAddressConfig: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AddNewCardComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-add-new-card',
                template: "<div class=\"d-none d-lg-flex\">\r\n  <button\r\n    class=\"btn add-card d-flex flex-column align-items-center justify-content-center\"\r\n    (click)=\"openCardModal(addNewCardForm)\"\r\n  >\r\n    <span class=\"icon material-icons\" aria-hidden=\"true\">add_card</span>\r\n    <label class=\"font-size-14 mb-0 cursor-pointer add-card-label\">{{ 'new.card.button.label' | translate }}</label>\r\n  </button>\r\n</div>\r\n<div class=\"d-block d-lg-none w-100\">\r\n  <button\r\n    class=\"btn w-100 add-card d-flex flex-row align-items-center justify-content-center\"\r\n    (click)=\"openCardModal(addNewCardForm)\"\r\n  >\r\n    <span class=\"icon material-icons\" aria-hidden=\"true\">add_circle_outline</span>\r\n    <label class=\"font-size-14 mb-0 cursor-pointer add-card-label\">{{ 'new.card.button.label' | translate }}</label>\r\n  </button>\r\n</div>\r\n\r\n<ng-template #addNewCardForm let-modal>\r\n  <div class=\"container p-2 overflow-auto\">\r\n    <div class=\"header d-flex flex-row justify-content-center mt-3\">\r\n      <span class=\"icon material-icons text-black mr-2\" aria-hidden=\"true\">add_card</span>\r\n      <h6 class=\"mt-1 font-weight-bold\">{{ 'new.card.form.title' | translate }}</h6>\r\n    </div>\r\n    <div class=\"content px-lg-4\">\r\n      <fgbcl-top-up-address\r\n        [regex]=\"regex\"\r\n        [topUpAddressConfig]=\"topUpAddressConfig\"\r\n        [hidden]=\"hideAddress\"\r\n        (submittedAddress)=\"submittedAddress($event)\"\r\n      ></fgbcl-top-up-address>\r\n      <div id=\"payment-gateway-area\" class=\"p-1 mt-3\"></div>\r\n      <div *ngIf=\"showCancelButton\" class=\"d-flex flex-row justify-content-center mb-3\">\r\n        <button id=\"cancel-button\" class=\"btn btn-danger w-50 font-weight-bold\" (click)=\"cancel()\">Cancel</button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n",
                styles: ["button:hover{color:#fff}.add-card-label{text-transform:uppercase}"]
            }]
    }], function () { return [{ type: ɵngcc1.CardTokenService }, { type: ɵngcc2.NgbModal }]; }, { regex: [{
            type: Input
        }], provider: [{
            type: Input
        }], redirectUrl: [{
            type: Input
        }], failureUrl: [{
            type: Input
        }], topUpAddressConfig: [{
            type: Input
        }] }); })();

class CardTokenComponent {
    constructor(cardTokenService, modalService) {
        this.cardTokenService = cardTokenService;
        this.modalService = modalService;
        this.showBack = false;
    }
    ngOnInit() { }
    setCardAsDefault() {
        this.cardTokenService.setCardAsDefault(this.cardToken.TokenId);
        this.close();
    }
    switchCardSide() {
        this.showBack = !this.showBack;
    }
    cardIsInactive() {
        return !this.cardToken.IsDefaultToken;
    }
    cardIsActive() {
        return this.cardToken.IsDefaultToken && !this.cardToken.Frozen;
    }
    cardIsFrozen() {
        return this.cardToken.Frozen && this.cardToken.IsDefaultToken;
    }
    freezeCard() {
        this.cardTokenService.setCardTokenFrozenState(this.cardToken.TokenId, true);
        this.close();
    }
    unfreezeCard() {
        this.cardTokenService.setCardTokenFrozenState(this.cardToken.TokenId, false);
        this.close();
    }
    deleteCard() {
        this.cardTokenService.deleteCardToken(this.cardToken.TokenId);
        this.close();
    }
    close() {
        this.modalService.dismissAll();
    }
}
CardTokenComponent.ɵfac = function CardTokenComponent_Factory(t) { return new (t || CardTokenComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.CardTokenService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.NgbModal)); };
CardTokenComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CardTokenComponent, selectors: [["fgbcl-card-token"]], inputs: { cardToken: "cardToken" }, decls: 13, vars: 1, consts: [[4, "ngTemplateOutlet"], ["paymentCardFront", ""], ["paymentCardBack", ""], ["freeze", ""], ["unfreeze", ""], ["delete", ""], ["activate", ""], [1, "payment-card", 3, "ngClass"], [1, "d-flex", "flex-row", "align-items-center", "justify-content-between"], ["class", "card-status active", 4, "ngIf"], ["class", "card-status inactive", 4, "ngIf"], ["class", "card-status frozen", 4, "ngIf"], [1, "btn-settings", "switch-side", "cog", 3, "click"], [1, "icon", "icon-settings-1", 3, "ngClass"], [1, "d-flex", "flex-row", "align-items-end", "justify-content-between", "m-2"], [1, "mb-0", "ml-1", "font-size-12", 3, "ngClass"], ["alt", "", 1, "card-type-image", 3, "src"], [1, "card-status", "active"], [1, "card-status", "inactive"], [1, "card-status", "frozen"], [1, "payment-card", "back", "align-items-center"], [1, "d-flex", "flex-row", "justify-content-end", "w-100"], [1, "btn-settings", "switch-side", "cancel", 3, "click"], [1, "icon", "icon-cancel-circle", "text-black", "font-weight-bold"], ["class", "btn-status w-80 freeze", "confirmModal", "", 3, "confirmContent", "confirm", 4, "ngIf"], ["class", "btn-status w-80 activate", "confirmModal", "", 3, "confirmContent", "confirm", 4, "ngIf"], ["class", "btn-status w-80 unfreeze", "confirmModal", "", 3, "confirmContent", "confirm", 4, "ngIf"], ["confirmModal", "", 1, "btn", "delete", "mb-3", 3, "confirmContent", "confirm"], [1, "text-danger", "font-size-12", "mb-0", "cursor-pointer"], ["confirmModal", "", 1, "btn-status", "w-80", "freeze", 3, "confirmContent", "confirm"], [1, "card-status", "cursor-pointer"], ["aria-hidden", "true", 1, "material-icons", "text-white", "font-size-18", "mr-1"], ["confirmModal", "", 1, "btn-status", "w-80", "activate", 3, "confirmContent", "confirm"], ["confirmModal", "", 1, "btn-status", "w-80", "unfreeze", 3, "confirmContent", "confirm"], [1, "text-center", "my-3"]], template: function CardTokenComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, CardTokenComponent_ng_container_0_Template, 1, 0, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, CardTokenComponent_ng_template_1_Template, 13, 16, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(3, CardTokenComponent_ng_template_3_Template, 11, 7, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(5, CardTokenComponent_ng_template_5_Template, 3, 6, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(7, CardTokenComponent_ng_template_7_Template, 3, 6, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(9, CardTokenComponent_ng_template_9_Template, 3, 6, "ng-template", null, 5, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(11, CardTokenComponent_ng_template_11_Template, 3, 6, "ng-template", null, 6, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        const _r3 = ɵngcc0.ɵɵreference(4);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.showBack ? _r3 : _r1);
    } }, directives: [ɵngcc4.NgTemplateOutlet, ɵngcc4.NgClass, ɵngcc4.NgIf, ɵngcc6.ConfirmModalDirective], pipes: [ɵngcc7.CreditCardNumberPipe, ɵngcc7.CardTypeImageUrlPipe, ɵngcc5.TranslatePipe], styles: [""] });
CardTokenComponent.ctorParameters = () => [
    { type: CardTokenService },
    { type: NgbModal }
];
CardTokenComponent.propDecorators = {
    cardToken: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CardTokenComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-card-token',
                template: "<ng-container *ngTemplateOutlet=\"showBack ? paymentCardBack : paymentCardFront\"></ng-container>\r\n\r\n<!-- Payment Card: Front -->\r\n<ng-template #paymentCardFront>\r\n  <div\r\n    class=\"payment-card\"\r\n    [ngClass]=\"{\r\n      'active-card': cardIsActive(),\r\n      'inactive-card': cardIsInactive(),\r\n      'frozen-card': cardIsFrozen()\r\n    }\"\r\n  >\r\n    <div class=\"d-flex flex-row align-items-center justify-content-between\">\r\n      <p *ngIf=\"cardIsActive()\" class=\"card-status active\">{{ 'payment.card.active' | translate }}</p>\r\n      <p *ngIf=\"cardIsInactive()\" class=\"card-status inactive\">{{ 'payment.card.inactive' | translate }}</p>\r\n      <p *ngIf=\"cardIsFrozen()\" class=\"card-status frozen\">{{ 'payment.card.frozen' | translate }}</p>\r\n      <button class=\"btn-settings switch-side cog\" (click)=\"switchCardSide()\">\r\n        <span class=\"icon icon-settings-1\" [ngClass]=\"cardIsInactive() ? 'text-black' : 'text-white'\"></span>\r\n      </button>\r\n    </div>\r\n    <div class=\"d-flex flex-row align-items-end justify-content-between m-2\">\r\n      <p class=\"mb-0 ml-1 font-size-12\" [ngClass]=\"cardIsInactive() ? 'text-black' : 'text-white'\">\r\n        {{ cardToken.CardNumber | creditCardNumber }}\r\n      </p>\r\n      <img alt=\"\" class=\"card-type-image\" src=\"{{ cardToken.CardType | cardTypeImageUrl }}\" />\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n\r\n<!-- Payment Card: Back -->\r\n<ng-template #paymentCardBack>\r\n  <div class=\"payment-card back align-items-center\">\r\n    <div class=\"d-flex flex-row justify-content-end w-100\">\r\n      <button class=\"btn-settings switch-side cancel\" (click)=\"switchCardSide()\">\r\n        <span class=\"icon icon-cancel-circle text-black font-weight-bold\"></span>\r\n      </button>\r\n    </div>\r\n    <button *ngIf=\"cardIsActive()\" class=\"btn-status w-80 freeze\" confirmModal [confirmContent]=\"freeze\" (confirm)=\"freezeCard()\">\r\n      <label class=\"card-status cursor-pointer\">\r\n        <span class=\"material-icons text-white font-size-18 mr-1\" aria-hidden=\"true\">ac_unit</span>\r\n        <span>{{ 'payment.card.freeze.label' | translate }}</span>\r\n      </label>\r\n    </button>\r\n    <button\r\n      *ngIf=\"cardIsInactive()\"\r\n      class=\"btn-status w-80 activate\"\r\n      confirmModal\r\n      [confirmContent]=\"activate\"\r\n      (confirm)=\"setCardAsDefault()\"\r\n    >\r\n      <label class=\"card-status cursor-pointer\">{{ 'payment.card.activate.label' | translate }}</label>\r\n    </button>\r\n    <button\r\n      *ngIf=\"cardIsFrozen()\"\r\n      class=\"btn-status w-80 unfreeze\"\r\n      confirmModal\r\n      [confirmContent]=\"unfreeze\"\r\n      (confirm)=\"unfreezeCard()\"\r\n    >\r\n      <label class=\"card-status cursor-pointer\">\r\n        <span class=\"material-icons text-white font-size-18 mr-1\" aria-hidden=\"true\">light_mode</span>\r\n        <span>{{ 'payment.card.unfreeze.label' | translate }}</span>\r\n      </label>\r\n    </button>\r\n    <button class=\"btn delete mb-3\" confirmModal [confirmContent]=\"delete\" (confirm)=\"deleteCard()\">\r\n      <label class=\"text-danger font-size-12 mb-0 cursor-pointer\">{{ 'payment.card.delete.label' | translate }}</label>\r\n    </button>\r\n  </div>\r\n</ng-template>\r\n\r\n<ng-template #freeze>\r\n  <div class=\"text-center my-3\">\r\n    {{ 'payment.card.freeze.confirmation' | translate: { cardEnding: cardToken.CardNumber.substring(12) } }}\r\n  </div>\r\n</ng-template>\r\n\r\n<ng-template #unfreeze>\r\n  <div class=\"text-center my-3\">\r\n    {{ 'payment.card.unfreeze.confirmation' | translate: { cardEnding: cardToken.CardNumber.substring(12) } }}\r\n  </div>\r\n</ng-template>\r\n\r\n<ng-template #delete>\r\n  <div class=\"text-center my-3\">\r\n    {{ 'payment.card.delete.confirmation' | translate: { cardEnding: cardToken.CardNumber.substring(12) } }}\r\n  </div>\r\n</ng-template>\r\n\r\n<ng-template #activate>\r\n  <div class=\"text-center my-3\">\r\n    {{ 'payment.card.activation.confirmation' | translate: { cardEnding: cardToken.CardNumber.substring(12) } }}\r\n  </div>\r\n</ng-template>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc1.CardTokenService }, { type: ɵngcc2.NgbModal }]; }, { cardToken: [{
            type: Input
        }] }); })();

class CardTokenListComponent {
    constructor(cardTokenQuery) {
        this.cardTokenQuery = cardTokenQuery;
        this.provider = ProviderName.Dummy;
        this.redirectUrl = '/payment';
        this.failureUrl = '/cardtoken/failure';
        this.regex = RegexUS;
        this.topUpAddressConfig = topUpAddressConfigDefault;
        this.customOptions = {
            items: 1,
            loop: false,
            autoHeight: true,
            autoWidth: true,
            margin: 15,
            autoplay: false,
            autoplayTimeout: 10000,
            autoplaySpeed: 1500,
        };
        this.customOptions2 = {
            items: 3,
            loop: false,
            touchDrag: false,
            autoHeight: true,
            autoWidth: true,
            margin: 22,
            autoplay: false,
            autoplayTimeout: 10000,
            autoplaySpeed: 1500,
        };
    }
    ngOnInit() {
        this.defaultCardToken$ = this.cardTokenQuery.selectDefaultCard();
        this.nonDefaultCardTokens$ = this.cardTokenQuery.selectExceptDefaultCard();
    }
}
CardTokenListComponent.ɵfac = function CardTokenListComponent_Factory(t) { return new (t || CardTokenListComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.CardTokenQuery)); };
CardTokenListComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CardTokenListComponent, selectors: [["fgbcl-card-token-list"]], inputs: { provider: "provider", redirectUrl: "redirectUrl", failureUrl: "failureUrl", regex: "regex", topUpAddressConfig: "topUpAddressConfig" }, decls: 10, vars: 17, consts: [[1, "payment-cards-title"], [1, "payment-cards-container"], [1, "w-mb-100", "add-card-btn", 3, "regex", "provider", "redirectUrl", "topUpAddressConfig", "failureUrl"], [4, "ngIf", "ngIfElse"], ["loadingRef", ""], [4, "ngIf"], [1, "mobile-cards-carousel"], [1, "card-padding", 3, "options"], [4, "ngFor", "ngForOf"], [1, "horizontal-line", "w-80"], [1, "desktop-cards-list"], ["carouselSlide", "", 3, "width"], [3, "cardToken"], [1, "add-card-border", "d-flex", "align-items-center", "justify-content-center", "rounded"]], template: function CardTokenListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "h3", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵpipe(2, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 1);
        ɵngcc0.ɵɵelement(4, "fgbcl-add-new-card", 2);
        ɵngcc0.ɵɵtemplate(5, CardTokenListComponent_ng_container_5_Template, 2, 1, "ng-container", 3);
        ɵngcc0.ɵɵpipe(6, "async");
        ɵngcc0.ɵɵpipe(7, "async");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, CardTokenListComponent_ng_template_8_Template, 1, 0, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(9);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 8, "payment.cards.title"), "\n");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("regex", ctx.regex)("provider", ctx.provider)("redirectUrl", ctx.redirectUrl)("topUpAddressConfig", ctx.topUpAddressConfig)("failureUrl", ctx.failureUrl);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpureFunction2(14, _c2, ɵngcc0.ɵɵpipeBind1(6, 10, ctx.defaultCardToken$), ɵngcc0.ɵɵpipeBind1(7, 12, ctx.nonDefaultCardTokens$)))("ngIfElse", _r1);
    } }, directives: [AddNewCardComponent, ɵngcc4.NgIf, ɵngcc8.CarouselComponent, ɵngcc4.NgForOf, ɵngcc8.CarouselSlideDirective, CardTokenComponent, ɵngcc9.LoadingComponent], pipes: [ɵngcc5.TranslatePipe, ɵngcc4.AsyncPipe], styles: [".payment-cards-container[_ngcontent-%COMP%]{display:flex;flex-direction:column-reverse}@media (min-width:992px){.payment-cards-container[_ngcontent-%COMP%]{flex-direction:row}}.payment-cards-container[_ngcontent-%COMP%]   .desktop-cards-list[_ngcontent-%COMP%]{display:none;min-width:calc(100% - 158px)}@media (min-width:992px){.payment-cards-container[_ngcontent-%COMP%]   .desktop-cards-list[_ngcontent-%COMP%]{display:block;float:left}}.payment-cards-container[_ngcontent-%COMP%]   .mobile-cards-carousel[_ngcontent-%COMP%]{display:none}@media (max-width:991px){.payment-cards-container[_ngcontent-%COMP%]   .mobile-cards-carousel[_ngcontent-%COMP%]{display:flex;flex-direction:column;width:100%}}@media (min-width:992px){.payment-cards-container[_ngcontent-%COMP%]   .add-card-btn[_ngcontent-%COMP%]{margin-right:16px;margin-top:5px}}.payment-cards-container[_ngcontent-%COMP%]   .add-card-border[_ngcontent-%COMP%]{border:2px dashed rgba(0,0,0,.1607843137254902);height:120px}"] });
CardTokenListComponent.ctorParameters = () => [
    { type: CardTokenQuery }
];
CardTokenListComponent.propDecorators = {
    provider: [{ type: Input }],
    redirectUrl: [{ type: Input }],
    failureUrl: [{ type: Input }],
    regex: [{ type: Input }],
    topUpAddressConfig: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CardTokenListComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-card-token-list',
                template: "<h3 class=\"payment-cards-title\">\r\n  {{ 'payment.cards.title' | translate }}\r\n</h3>\r\n\r\n<div class=\"payment-cards-container\">\r\n  <fgbcl-add-new-card\r\n    [regex]=\"regex\"\r\n    [provider]=\"provider\"\r\n    [redirectUrl]=\"redirectUrl\"\r\n    [topUpAddressConfig]=\"topUpAddressConfig\"\r\n    [failureUrl]=\"failureUrl\"\r\n    class=\"w-mb-100 add-card-btn\"\r\n  ></fgbcl-add-new-card>\r\n  <ng-container\r\n    *ngIf=\"{ defaultCard: defaultCardToken$ | async, otherCards: nonDefaultCardTokens$ | async } as cardTokens; else loadingRef\"\r\n  >\r\n    <ng-container *ngIf=\"cardTokens.defaultCard || cardTokens.otherCards.length\">\r\n      <div class=\"mobile-cards-carousel\">\r\n        <owl-carousel-o [options]=\"customOptions\" class=\"card-padding\">\r\n          <ng-template carouselSlide *ngIf=\"cardTokens.defaultCard\" [width]=\"224\">\r\n            <fgbcl-card-token [cardToken]=\"cardTokens.defaultCard\"></fgbcl-card-token>\r\n          </ng-template>\r\n          <ng-container *ngFor=\"let card of cardTokens.otherCards\">\r\n            <ng-template carouselSlide [width]=\"224\">\r\n              <fgbcl-card-token [cardToken]=\"card\"></fgbcl-card-token>\r\n            </ng-template>\r\n          </ng-container>\r\n          <ng-template *ngIf=\"cardTokens.otherCards\" [width]=\"224\" carouselSlide>\r\n            <div class=\"add-card-border d-flex align-items-center justify-content-center rounded\"></div>\r\n          </ng-template>\r\n        </owl-carousel-o>\r\n        <hr class=\"horizontal-line w-80\" />\r\n      </div>\r\n\r\n      <div class=\"desktop-cards-list\">\r\n        <owl-carousel-o [options]=\"customOptions2\" class=\"card-padding\">\r\n          <ng-template carouselSlide *ngIf=\"cardTokens.defaultCard\" [width]=\"224\">\r\n            <fgbcl-card-token [cardToken]=\"cardTokens.defaultCard\"></fgbcl-card-token>\r\n          </ng-template>\r\n          <ng-container *ngFor=\"let token of cardTokens.otherCards\">\r\n            <ng-template carouselSlide [width]=\"224\">\r\n              <fgbcl-card-token [cardToken]=\"token\"></fgbcl-card-token>\r\n            </ng-template>\r\n          </ng-container>\r\n        </owl-carousel-o>\r\n      </div>\r\n    </ng-container>\r\n  </ng-container>\r\n</div>\r\n\r\n<ng-template #loadingRef>\r\n  <fgbcl-loading></fgbcl-loading>\r\n</ng-template>\r\n",
                styles: [".payment-cards-container{display:flex;flex-direction:column-reverse}@media (min-width:992px){.payment-cards-container{flex-direction:row}}.payment-cards-container .desktop-cards-list{display:none;min-width:calc(100% - 158px)}@media (min-width:992px){.payment-cards-container .desktop-cards-list{display:block;float:left}}.payment-cards-container .mobile-cards-carousel{display:none}@media (max-width:991px){.payment-cards-container .mobile-cards-carousel{display:flex;flex-direction:column;width:100%}}@media (min-width:992px){.payment-cards-container .add-card-btn{margin-right:16px;margin-top:5px}}.payment-cards-container .add-card-border{border:2px dashed rgba(0,0,0,.1607843137254902);height:120px}"]
            }]
    }], function () { return [{ type: ɵngcc1.CardTokenQuery }]; }, { provider: [{
            type: Input
        }], redirectUrl: [{
            type: Input
        }], failureUrl: [{
            type: Input
        }], regex: [{
            type: Input
        }], topUpAddressConfig: [{
            type: Input
        }] }); })();

class CardTokenListModule {
}
CardTokenListModule.ɵfac = function CardTokenListModule_Factory(t) { return new (t || CardTokenListModule)(); };
CardTokenListModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: CardTokenListModule });
CardTokenListModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            LoadingModule,
            PipesModule,
            ConfirmModalModule,
            CountryAndRegionsModule,
            TopUpAddressModule,
            CommonModule,
            CarouselModule,
            FormsModule,
            ReactiveFormsModule,
            NgbModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CardTokenListModule, { declarations: function () { return [CardTokenListComponent, CardTokenComponent, AddNewCardComponent]; }, imports: function () { return [LoadingModule,
        PipesModule,
        ConfirmModalModule,
        CountryAndRegionsModule,
        TopUpAddressModule,
        CommonModule,
        CarouselModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule, ɵngcc5.TranslateModule]; }, exports: function () { return [CardTokenListComponent, AddNewCardComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CardTokenListModule, [{
        type: NgModule,
        args: [{
                declarations: [CardTokenListComponent, CardTokenComponent, AddNewCardComponent],
                imports: [
                    LoadingModule,
                    PipesModule,
                    ConfirmModalModule,
                    CountryAndRegionsModule,
                    TopUpAddressModule,
                    CommonModule,
                    CarouselModule,
                    FormsModule,
                    ReactiveFormsModule,
                    NgbModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [CardTokenListComponent, AddNewCardComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { AddNewCardComponent, CardTokenComponent, CardTokenListComponent, CardTokenListModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-ecash-card-token-list.js.map